module.exports = __webpack_public_path__ + "img/clock.ffa3b21e.svg";